import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const isDateEnabled = (
    date: Date,
    activityGroupStartDay: dayjs.Dayjs,
    activityGroupEndDay: dayjs.Dayjs,
    selectedWeekStartDay: dayjs.Dayjs,
    selectedWeekEndDay: dayjs.Dayjs,
) => {
    const dateObj = dayjs(date);

    return (
        dateObj.isSameOrAfter(activityGroupStartDay, 'day') &&
        dateObj.isSameOrBefore(activityGroupEndDay, 'day') &&
        dateObj.isSameOrAfter(selectedWeekStartDay, 'day') &&
        dateObj.isSameOrBefore(selectedWeekEndDay, 'day')
    );
};

export const getDateDisabledReason = (
    date: Date,
    activityGroupStartDay: dayjs.Dayjs,
    activityGroupEndDay: dayjs.Dayjs,
    selectedWeekStartDay: dayjs.Dayjs,
) => {
    const dateObj = dayjs(date);

    if (dateObj.isBefore(activityGroupStartDay, 'day')) {
        return `Date must be on or after ${activityGroupStartDay.format('MMMM D, YYYY')}`;
    }

    if (dateObj.isAfter(activityGroupEndDay, 'day')) {
        return `Date must be on or before ${activityGroupEndDay.format('MMMM D, YYYY')}`;
    }

    if (
        dateObj.isBefore(selectedWeekStartDay, 'day') ||
        dateObj.isAfter(selectedWeekStartDay.add(6, 'day'), 'day')
    ) {
        return `To schedule sessions in other weeks, use the Week dropdown above. Current week: ${selectedWeekStartDay.format('MMMM D')}`;
    }

    return undefined;
};
